import { Resume } from '@sr/types';
import Sections from '../common/Sections';
import { Box } from '../common/ui';
import OverpassFont from '../fonts/OverpassFont';
import BlockListSection from './BlockListSection';
import DetailSection from './DetailSection';
import theme from './eton-theme';
import Header from './Header';
import InlineListSection from './InlineListSection';

const Eton = ({ resume }: { resume: Resume }) => {
  return (
    <>
      <OverpassFont />
      <Header resume={resume} />
      <Box className="pdf-page-container">
        <Box className="pdf-page-column">
          <Sections
            resume={resume}
            filter="all"
            DetailSection={DetailSection}
            BlockListSection={BlockListSection}
            InlineListSection={InlineListSection}
          />
        </Box>
      </Box>
    </>
  );
};

Eton.theme = theme;
export default Eton;
